import styled from 'styled-components'

export const StyledUndoButton = styled.button`
    text-decoration: underline;
    cursor: pointer;
    font-weight: 500;
`
